module.exports = __webpack_public_path__ + "a36db5ee2456831a8fdd8775a4c7fc82.svg";